<template>
  <div class="app-main-content oc-payment">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          :is-append-query="false"
          :show-more-scheme="true"
          :show-simple="true"
          :expand-adv="true"
          :search-item-code="$t('CargoMsg.Cargo_OcPayment')"
          config-module="514"
          :auto-init="true"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('Clearing.QuickSearchBusinessNumber')"
          @advSearchItemCallBack="fetchData"
          @simSearchItemCallBack="fetchDataBykeyWord"
        >
          <template slot="operations">
            <el-button type="primary" @click="processHandler">{{ $t('CargoMsg.Cargo_BatchProcess') }}</el-button>
            <el-button type="primary" @click="cancelProcessHandler">{{ $t('CargoMsg.Cargo_BatchCancelProcess') }}</el-button>
          </template>
          <template v-slot:other>
            <el-form :inline="true" label-width="60px" label-position="left" style="margin-left: 15px;">
              <el-form-item :label="$t('CargoMsg.Cargo_OcPaymentTime')" class="el-form-item-search">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        type="date"
                        style="margin-right: 0px;"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="2"><span>{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        type="date"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </template>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="191301"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :check-main-record="false"
            :deselect-main-record="false"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            style="width: 100%;"
          />
        </div>
        <div id="footer-wrapper" class="pagination-wrapper">
          <cargo-pagination
            config-module="191301"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
    <!-- 收款金额 -->
    <update-received-amount-dialog
      :visible.sync="updateReceivedAmountDialog.visible"
      :oc-payment="updateReceivedAmountDialog.ocPayment"
      @success="refresh"
    />
    <!-- 异常标记 -->
    <mark-abnormal-dialog
      :visible.sync="markAbnormalDialog.visible"
      :oc-payment="markAbnormalDialog.ocPayment"
      @success="refresh"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { queryOcPaymentList, processOcPayment } from '@/api/clearing/ocPayment'
import { formatNumberToThousands } from '@/utils'
import moment from 'moment'
import { cacheName, cache } from '@/utils/cacheManager'
import { getGridSelected } from '@/utils/agGrid'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import pdf from 'vue-pdf'
import updateReceivedAmountDialog from '@/views/cargo/v0/Clearing/components/ocPayment/updateReceivedAmountDialog'
import markAbnormalDialog from '@/views/cargo/v0/Clearing/components/ocPayment/markAbnormalDialog'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'

export default {
  name: 'OcPayment',
  components: { searchItem, CargoDialog, pdf, updateReceivedAmountDialog, markAbnormalDialog, preViewFileDialog },
  data() {
    return {
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      documentManage: new DocumentManage(),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_OcPaymentTime'), field: 'paymentTime', width: 140 },
        { headerName: this.$t('CargoMsg.Cargo_ErialNumber'), field: 'erialNumber', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_OcErialNumber'), field: 'ocErialNumber', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_BillingAccountId'), field: 'accountId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillingSettlementAgentId'), field: 'settlementAgentId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Processed'), field: 'processed', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.ocProcessedLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_Project'), field: 'project', width: 100,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'orderNo', width: 140,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'orderNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.toSearchTemplate
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billNo', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: false,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'orderNo', defActiveTab: 'billingType' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.toSearchTemplate
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentStatus'), field: 'paymentStatus', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.ocPaymentStatusLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' },
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 80,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillingAmount'), field: 'amount', width: 100,
          cellRenderer: (params) => {
            return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentMethod'), field: 'paymentMethod', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.ocPaymentMethodLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'ISID', field: 'isid', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_ActualPaymentAmount'), field: 'actualPaymentAmount', width: 100,
          cellRenderer: (params) => {
            return params.data.actualPaymentAmountOc === '' ? '' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReceivedAmount'), field: 'receivedAmount', width: 100,
          cellRenderer: (params) => {
            return params.data.receivedAmountOc === '' ? '' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OcServiceCharge'), field: 'ocServiceCharge', width: 100,
          cellRenderer: (params) => {
            return params.data.ocServiceChargeOc === '' ? '' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChannelServiceCharge'), field: 'channelServiceCharge', width: 120,
          cellRenderer: (params) => {
            return params.data.channelServiceChargeOc === '' ? '' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Abnormal'), field: 'abnormal', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_AbnormalState'), field: 'abnormalState', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.ocAbnormalStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AbnormalRemark'), field: 'abnormalRemark', width: 150 },
        { headerName: this.$t('CargoMsg.Cargo_ProcessedDate'), field: 'processedDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'fileId',
          width: 200,
          cellRenderer: params => {
            let preview = ''
            const fileStr = params.data.fileName
            const location = fileStr.lastIndexOf('.')
            let type = fileStr.substring(location + 1, fileStr.length)
            if (StrUtils.isEmpty(type)) type = 'png'
            if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'gif' || type === 'webp' || type === 'pdf' ||
              type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
              const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
              preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
            }
            let receivedAmount = ''
            if (params.data.paymentMethod === SystemConstants.OCPAYMENT_METHOD_4.code) {
              const updateReceivedAmountPath = this.documentManage.getPath('updateReceivedAmount')
              receivedAmount = `<a onclick="${updateReceivedAmountPath}('${params.data.uuid}')" style="color:blue">${this.$t('CargoMsg.Cargo_ReceiptAmount')}</a>&nbsp;`
            }
            const markAbnormalPath = this.documentManage.getPath('markAbnormal')
            const abnormal = `<a onclick="${markAbnormalPath}('${params.data.uuid}')" style="color:blue">${this.$t('CargoMsg.Cargo_AbnormalComment')}</a>&nbsp;`
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return receivedAmount + abnormal + `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">
                    ${this.$t('FileHistory.fileDownload')}
                    </a>` + preview
          }
        }
      ],
      rowData: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false,
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: ''
      },
      storageURL: '',
      user: {},
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      },
      pdfSrc: '',
      numPages: '',
      photoList: [],
      officeFileUrl: '',
      updateReceivedAmountDialog: {
        visible: false,
        ocPayment: {}
      },
      markAbnormalDialog: {
        visible: false,
        ocPayment: {}
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('CargoMsg.Cargo_UnlockPaymentTimeQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(() => {
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
    this.documentManage.set('updateReceivedAmount', function(value) {
      context.updateReceivedAmount(value)
    })
    this.documentManage.set('markAbnormal', function(value) {
      context.markAbnormal(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.user = cache.user
    this.storageURL = cache.config.get('StorageURL')
    const defaultSearchFields = []
    // 结算单位
    let searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'company'
    searchField.subType = { 'type': '', 'tagValue': 'cmpIdx' }
    searchField.fieldType = 'FIELD_COMPANY'
    searchField.itemName = 'billing.ACCOUNTID'
    searchField.itemLabel = 'CargoMsg.Cargo_BillingAccountId'
    searchField.defaultSelected = 1
    searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
    defaultSearchFields.push(searchField.formatObj2Json())
    // 结算代理
    searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'company'
    searchField.subType = { 'type': ['settlementAgent'], 'tagValue': 'cmpIdx' }
    searchField.fieldType = 'FIELD_COMPANY'
    searchField.itemName = 'billing.SETTLEMENT_AGENT_ID'
    searchField.itemLabel = 'CargoMsg.Cargo_BillingSettlementAgentId'
    searchField.defaultSelected = 1
    searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
    defaultSearchFields.push(searchField.formatObj2Json())
    this.customSearchItems = defaultSearchFields
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        // 支付日期
        let inputDate = ''
        if (this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00' + ',end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (!this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (this.searchConditions.inputDateStart && !this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00'
        }
        if (inputDate) {
          const condition = new AdvancedSearchOption(null, 'payment.PAYMENT_TIME', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
          finallyConditions.push(condition.formatObj2Json())
        }
      }
      finallyConditions.push(...conditions)
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'payment.ORDER_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryList()
    },
    toQueryList() {
      const { snapshotConditions: conditions, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': 'OcPayment' }
      this.loading = getLoading()
      queryOcPaymentList(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 处理
    processHandler() {
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('processHandler', rowDataSelected)
      const list = []
      for (const item of rowDataSelected) {
        if (!item.processed && item.paymentMethod === SystemConstants.OCPAYMENT_METHOD_4.code) {
          const ocPayment = {}
          ocPayment.uuid = item.uuid
          ocPayment.processed = true
          ocPayment.processedBy = this.$store.getters.userInfo.userId
          list.push(ocPayment)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyUnProcessedRecordsCanBeProcessed'))
        return
      } else {
        const self = this
        self.$confirm(this.$t('CargoMsg.Cargo_ConfirmAndProcessSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          self.loading = getLoading()
          processOcPayment(list).then(res => {
            // 刷新
            for (const item of rowDataSelected) {
              if (!item.processed && item.paymentMethod === SystemConstants.OCPAYMENT_METHOD_4.code) {
                item.processed = true
                item.processedBy = this.$store.getters.userInfo.userId
                item.processedDate = new Date()
              }
            }
            this.gridOptions.api.refreshCells({ force: true })
            self.$message.success(this.$t('CargoMsg.Cargo_ProcessedSuccessfully'))
          }).finally(() => {
            self.loading.close()
          })
        }).catch(() => {
          //
        })
      }
    },
    // 取消处理
    cancelProcessHandler() {
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('cancelProcessHandler', rowDataSelected)
      const list = []
      for (const item of rowDataSelected) {
        if (item.processed && item.paymentMethod === SystemConstants.OCPAYMENT_METHOD_4.code) {
          const ocPayment = {}
          ocPayment.uuid = item.uuid
          ocPayment.processed = false
          list.push(ocPayment)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyProcessedRecordsCanBeCancelled'))
        return
      } else {
        const self = this
        self.$confirm(this.$t('CargoMsg.Cargo_CancelProcessOfSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          self.loading = getLoading('app-main-content')
          processOcPayment(list).then(res => {
            // 刷新
            for (const item of rowDataSelected) {
              if (item.processed && item.paymentMethod === SystemConstants.OCPAYMENT_METHOD_4.code) {
                item.processed = false
                item.processedBy = 0
                item.processedDate = null
              }
            }
            this.gridOptions.api.refreshCells({ force: true })
            self.$message.success(this.$t('CargoMsg.Cargo_CancelProcessSuccessfully'))
          }).finally(() => {
            self.loading.close()
          })
        }).catch(() => {
          //
        })
      }
    },
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    updateReceivedAmount(value) {
      console.log('updateReceivedAmount', value)
      let ocPayment = {}
      for (const item of this.rowData) {
        if (value === item.uuid) {
          ocPayment = item
          break
        }
      }
      this.updateReceivedAmountDialog.ocPayment = ocPayment
      this.updateReceivedAmountDialog.visible = true
    },
    markAbnormal(value) {
      console.log('markAbnormal', value)
      let ocPayment = {}
      for (const item of this.rowData) {
        if (value === item.uuid) {
          ocPayment = item
          break
        }
      }
      this.markAbnormalDialog.ocPayment = ocPayment
      this.markAbnormalDialog.visible = true
    },
    refresh(list) {
      if (!list) return
      for (const item of list) {
        for (const row of this.rowData) {
          if (item.uuid === row.uuid) {
            row.abnormal = item.abnormal
            row.abnormalState = item.abnormalState
            row.abnormalRemark = item.abnormalRemark
            row.receivedAmount = item.receivedAmount
            row.ocServiceCharge = item.ocServiceCharge
          }
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
.oc-payment {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 13px !important;
    }
    .el-form-item__content {
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
